import { registerRemotes } from '@module-federation/enhanced/runtime'
import { mfManifestsPath } from './mf-manifests/mf-manifest'

/** マニフェストのベースURLから remoteEntry の絶対URLを組み立てる（Firebase は /remoteEntry.mjs にデプロイ） */
function toRemoteEntryUrl(baseUrl: string): string {
  const base = baseUrl.replace(/\/$/, '')
  return `${base}/remoteEntry.mjs`
}

fetch(mfManifestsPath)
  .then((res) => res.json())
  .then((definitions: Record<string, string>) =>
    Object.entries(definitions).map(([name, baseUrl]) => ({
      name,
      entry: toRemoteEntryUrl(baseUrl),
      type: 'module' as const,
    }))
  )
  .then((remotes) => registerRemotes(remotes))
  .then(() => import('./bootstrap').catch((err) => console.error(err)))
